import { css, cx } from 'linaria';
export const betaTag = "b4tghaq";
export const BetaTag = ({
  children,
  className,
  ...args
}) => <span className={cx(className, betaTag, 'beta')} {...args}>
    {children}
  </span>;

require("./tag-beta.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag-beta.js");